import { render, staticRenderFns } from "./AdminSnippetAdd.vue?vue&type=template&id=376a9049&"
import script from "./AdminSnippetAdd.vue?vue&type=script&lang=js&"
export * from "./AdminSnippetAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports